/**
 * Список маршрутов
 */
export const RouteList = {
  HOME: '/',
  LOGIN: '/login',
  AUTH: '/auth',

  BOOKS: '/books',
  BOOK_DETAILS: (bookId: string) => `/books/${bookId}`,
  EDIT_BOOK: (bookId: string) => `/books/${bookId}/edit`,
  LESSON_DETAILS: (bookId: string, lessonId: string) =>
    `/books/${bookId}/lesson/${lessonId}`,
  BATCH_LESSON_UPLOAD: (bookId: string) =>
    `/books/${bookId}/lessons/batch-upload`,

  CATEGORIES: '/categories',
  CREATE_CATEGORY: '/categories/create',
  CATEGORY_DETAILS: (categoryId: string) => `/categories/${categoryId}`,
  EDIT_CATEGORY: (categoryId: string) => `/categories/${categoryId}/edit`,

  AUTHORS: '/authors',
  CREATE_AUTHOR: '/authors/create',
  AUTHOR_DETAILS: (authorId: string) => `/authors/${authorId}`,
  EDIT_AUTHOR: (authorId: string) => `/authors/${authorId}/edit`,

  PUBLISHERS: '/publishers',
  PUBLISHER_DETAILS: (publisherId: string) => `/publishers/${publisherId}`,
  CREATE_PUBLISHER: '/publishers/create',
  EDIT_PUBLISHER: (publisherId: string) => `/publishers/${publisherId}/edit`,
};
